import { EpiLink, MaterialIcon } from '@api/types';
import { HeaderIconButton, SmartLink } from '@components';
import { useAppSelector, useAuth } from '@hooks';
import { Box } from '@mui/material';
import { getSpecialPage } from '@store/app/app.slice';
import { getCartTotalItems } from '@store/cart/cart.slice';
import React from 'react';

export type HeaderCartButtonProps = {
  children?: React.ReactNode;
  link?: EpiLink;
  icon?: MaterialIcon;
};

export const HeaderCartButton = () => {
  const { isAuthenticated } = useAuth();
  const totalItems = useAppSelector(getCartTotalItems);
  const cartPageUrl = useAppSelector(getSpecialPage('cartPage'));
  return isAuthenticated ? (
    <Box className='cart-link-block' sx={{ display: 'flex', alignItems: 'center' }}>
      <SmartLink href={cartPageUrl}>
        <HeaderIconButton iconName='ShoppingCart' sx={{ ml: 'auto' }} badgeContent={totalItems} />
      </SmartLink>
    </Box>
  ) : null;
};
